import { EndUseStackedBarChart } from "components/organisms/Charts";
import { useAnnualCarbonEmissionsElectricityChart } from "queries/Reports/Baseline/useAnnualCarbonEmissionsElectricityChart";
import { useMemo } from "react";

function AnnualCarbonEmissionsElectricityChart({ filtersetUid }: { filtersetUid: string }) {
    const { data, isLoading, error } = useAnnualCarbonEmissionsElectricityChart(filtersetUid);
    // [DP 2025-12-10]: We currently do not have an effective way of visually representing
    // negaive carbon emission on this chart. Check slack to reference the reason behind this
    // temporary fix.
    // https://audetteio.slack.com/archives/C05UQEXHM6C/p1765590565774649?thread_ts=1765573955.807979&cid=C05UQEXHM6C
    const dataWithoutRenewables = useMemo(() => {
        if (!data) return [];
        // @ts-ignore
        return data.map(({ renewable, ...rest }) => rest);
    }, [data]);

    return (
        <EndUseStackedBarChart
            data={dataWithoutRenewables}
            loading={isLoading}
            fuelTypeKey="electricity"
            error={error?.toString()}
        />
    );
}

export default AnnualCarbonEmissionsElectricityChart;
